module.exports = require('./dist/lib/router')



//////////////////
// WEBPACK FOOTER
// ../node_modules/next/router.js
// module id = ../node_modules/next/router.js
// module chunks = 5